/* Example
 <SelectFromList :title="$t('stores.inventoryName')"            //Dialog Title
                 :inputTitle="$t('stores.inventoryName')"       //input text filed title
                 :items="inventoriesForSelect"                  //item list to display
                 displayString="name"                           //name of the object key to display
                 :displayField="inventory"                      //the field to display in input text field
                 @selected="inventorySelected"                  //selection event
                 :disabled="false"
                 class="margin-top-20 margin-bottom-10"/>

                 Events: @close @open for selection modal
                 @cleared

*/
export default {
  name: "SelectFromList",
  props: {
    items: {
      type: Array,
      required: true,
    },
    displayString: {
      type: String,
      default: "displayString",
    },
    displayField: {
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    inputTitle: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EmptyState: require("@/customcontrols/emptyState/emptyState.vue").default,
  },
  data: function () {
    return {
      showDialog: false,
      selectionDisplay: "",
      searchTerm: "",
      pagination: { pageSize: 100, total: null, page: 1 },
    };
  },
  computed: {
    itemsList: function () {
      let temp = [];
      let srch = this.searchTerm ? this.searchTerm.toLowerCase() : "";

      if (!this.items || this.items.length == 0) return [];

      this.items.forEach((t) => {
        if (
          t[this.displayString] &&
          t[this.displayString].toLowerCase().includes(srch)
        )
          temp.push(t);
      });

      this.pagination.total = temp.length;

      temp = temp.slice(0, this.pagination.page * this.pagination.pageSize);

      return temp;
    },
    showLoadButton: function () {
      return (
        this.pagination.page * this.pagination.pageSize < this.pagination.total
      );
    },
    itemsLength: function () {
      return this.items && this.items.length ? this.items.length : 0;
    },
  },
  watch: {
    displayField: function (val) {
      if (val) {
        this.populateDisplayField();
      } else this.selectionDisplay = "";
    },
    itemsLength: function (val) {
      if (val == 0 || !this.isMultiple) return;

      for (let i = 0; i < val; i++) {
        this.items[i]["isItemSelected"] = false;
        this.items[i]["selectFromListId"] = i;
      }
    },
  },
  mounted() {
    this.$root.$on("reset_select_from_list", this.reset);
  },
  methods: {
    reset() {
      for (let i = 0; i < this.itemsLength; i++) {
        this.items[i]["isItemSelected"] = false;
        this.items[i]["selectFromListId"] = i;
      }

      this.selectionDisplay = "";
    },
    populateDisplayField() {
      if (this.isMultiple) {
        let temp = this.items.filter((i) => i.isItemSelected);
        this.selectionDisplay = "";
        if (temp && temp.length > 0) {
          temp.forEach(
            (t) => (this.selectionDisplay += t[this.displayString] + " ")
          );
        }
      } else this.selectionDisplay = this.displayField[this.displayString];
    },
    openDialog(bool) {
      this.showDialog = this.disabled ? false : bool;

      this.$emit(this.showDialog ? "open" : "close");
    },
    itemSelected(item) {
      if (this.isMultiple) {
        let temp = this.items.filter(
          (i) => i.selectFromListId == item.selectFromListId
        )[0];
        temp.isItemSelected = !temp.isItemSelected;

        this.$forceUpdate();
      } else {
        this.openDialog(false);
        this.$emit("selected", item);
      }
    },
    selectionFinalised() {
      this.openDialog(false);
      let results = [...this.items.filter((i) => i.isItemSelected)];
      this.populateDisplayField();

      this.$emit("selected", results);
    },
    scrollUp() {
      this.$scrollToElement("list_select_search");
    },
    loadMoreResults() {
      this.pagination.page++;
    },
    dialogOpenedClosed() {
      this.searchTerm = "";
      this.resetPagination();
    },
    resetPagination() {
      this.pagination = {
        pageSize: 100,
        total: this.itemsList.length,
        page: 1,
      };
    },
    getListItemClass(index, item) {
      let clss = index == 0 ? "list-item-first list-item" : "list-item";

      if (
        this.displayField &&
        this.displayField.id &&
        item &&
        item.id &&
        item.id == this.displayField.id
      )
        clss = clss + " highlighted-cell";

      if (item.isItemSelected) clss = clss + " selected-cell";

      return clss;
    },

    clearField() {
      this.$emit("cleared");
    },
  },
};
